module.exports = {"610922100":"城关镇","610922101":"饶峰镇","610922102":"两河镇","610922103":"迎丰镇","610922104":"池河镇","610922105":"后柳镇","610922106":"喜河镇","610922107":"熨斗镇","610922108":"云雾山镇","610922109":"中池镇","610922110":"曾溪镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610922.json
// module id = 2664
// module chunks = 0